<script lang="ts">
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";
    import { slide } from "svelte/transition";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";
    import CloseIcon from "@components/icons/CloseIcon.svelte";

    export let type: "error" | "warning" | "success" | "info" = "info";
    export let variant: "outlined" | "filled" | "standart" = "standart";
    let className = "";
    export { className as class };
    export let hideClose = false;
    export let buttonClass = "";

    export let show = true;

    const dispatch = createEventDispatcher();

    const handleClose = () => {
        dispatch("close");
    };
</script>

{#if show}
    <div
        transition:slide={{ duration: 400 }}
        class={CN(
            "gw-alert",
            `gw-alert-type-${type}`,
            `gw-alert-variant-${variant}`,
            className
        )}
        role="alert"
    >
        <div class="gw-alert__message">
            <slot />
        </div>
        {#if !hideClose}
            <BaseButton
                class={CN(
                    "gw-alert__close-btn gw-button-reset-default-styles",
                    buttonClass
                )}
                aria-label="close alert"
                on:click={handleClose}
            >
                <Icon width={12} height={12}>
                    <CloseIcon />
                </Icon>
            </BaseButton>
        {/if}
    </div>
{/if}

<style lang="postcss">
    .gw-alert {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.9em;
        border-radius: 4px;

        &-type {
            &-error {
                --standartColor: var(--gw-alert-standart-error);
                --outlinedColor: var(--gw-alert-outlined-error);
                --filledColor: var(--gw-alert-filled-error);
                --textColor: var(--gw-alert-text-color-error);
            }

            &-warning {
                --standartColor: var(--gw-alert-standart-warning);
                --outlinedColor: var(--gw-alert-outlined-warning);
                --filledColor: var(--gw-alert-filled-warning);
                --textColor: var(--gw-alert-text-color-warning);
            }

            &-success {
                --standartColor: var(--gw-alert-standart-success);
                --outlinedColor: var(--gw-alert-outlined-success);
                --filledColor: var(--gw-alert-filled-success);
                --textColor: var(--gw-alert-text-color-success);
            }

            &-info {
                --standartColor: var(--gw-alert-standart-info);
                --outlinedColor: var(--gw-alert-outlined-info);
                --filledColor: var(--gw-alert-filled-info);
                --textColor: var(--gw-alert-text-color-info);
            }
        }

        &-variant {
            &-outlined {
                border: 1px solid var(--outlinedColor);
                color: var(--textColor);
            }

            &-filled {
                background-color: var(--filledColor);
                color: var(--gw-alert-text-color-white);
            }

            &-standart {
                background-color: var(--standartColor);
                color: var(--textColor);
            }
        }
    }

    :global(.gw-alert__close-btn) {
        color: inherit;
    }
</style>
